import AppShowcase from './AppShowcase.js';

/**
 * AppContent - Displays individual app content in a tab using AppShowcase
 */
export default class AppContent {
  constructor(container, slug) {
    this.container = container;
    this.slug = slug;
  }

  async render() {
    this.container.innerHTML = `
      <div class="app-content">
        <div class="app-loading">
          <p>Loading app...</p>
        </div>
      </div>
    `;

    try {
      // Fetch content from the Astro server
      const appData = await this.fetchAppContent(this.slug);
      
      if (appData) {
        this.renderAppShowcase(appData);
      } else {
        throw new Error('App not found');
      }
      
    } catch (error) {
      console.error('Error loading app:', error);
      this.showError('Failed to load app content');
    }
  }

  async fetchAppContent(slug) {
    try {
      // Determine the correct API URL
      let apiUrl;
      const isDevelopment = window.location.hostname === 'localhost' || 
                           window.location.hostname === '127.0.0.1' ||
                           window.location.hostname.includes('localhost') ||
                           window.location.port === '3000' || 
                           window.location.port === '3001' ||
                           window.location.port === '3002' ||
                           window.location.port === '3003' ||
                           window.location.port === '3004' ||
                           window.location.port === '3005' ||
                           window.location.port === '3006' ||
                           window.location.port === '3007' ||
                           window.location.port === '3008' ||
                           window.location.port === '3009' ||
                           window.location.port === '3010';
      
      if (isDevelopment) {
        // Development: Use the local Astro dev server
        apiUrl = `http://localhost:4321/api/apps/${slug}.json`;
      } else {
        // Production: Use the actual build location
        apiUrl = `/file/ologies/api/apps/${slug}.json`;
      }
      
      // Try to fetch from the API endpoint
      const response = await fetch(apiUrl);
      
      if (response.ok) {
        const data = await response.json();
        
        if (data.error) {
          throw new Error(data.error);
        }
        
        return {
          slug: data.slug,
          title: data.title,
          subtitle: data.subtitle,
          description: data.description,
          appStoreUrl: data.appStoreUrl,
          websiteUrl: data.websiteUrl,
          appIconUrl: data.appIconUrl,
          screenshotUrls: data.screenshotUrls || [],
          screenshotData: data.screenshotData || [],
          category: data.category,
          rating: data.rating || 5,
          status: data.status || 'live',
          publishDate: data.publishDate,
          tags: data.tags || [],
          featured: data.featured || false,
          author: data.author,
          content: data.content
        };
      }
      
      // If API is not available, throw error
      throw new Error(`API not available at ${apiUrl}`);
      
    } catch (error) {
      console.error('Failed to fetch app:', error);
      throw error;
    }
  }

  renderAppShowcase(appData) {
    // Clear the loading state
    this.container.innerHTML = '';
    
    // Create and render the AppShowcase component
    const appShowcase = new AppShowcase(this.container, appData);
    appShowcase.render();
  }

  showError(message) {
    const isDevelopment = window.location.hostname === 'localhost' || 
                         window.location.hostname === '127.0.0.1' ||
                         window.location.hostname.includes('localhost') ||
                         window.location.port === '3000' || 
                         window.location.port === '3001' ||
                         window.location.port === '3002' ||
                         window.location.port === '3003' ||
                         window.location.port === '3004' ||
                         window.location.port === '3005' ||
                         window.location.port === '3006' ||
                         window.location.port === '3007' ||
                         window.location.port === '3008' ||
                         window.location.port === '3009' ||
                         window.location.port === '3010';
    
    this.container.innerHTML = `
      <div class="app-content">
        <div class="error-message">
          <h2>Unable to Load App</h2>
          <p>${message}</p>
          ${isDevelopment ? `
            <p><strong>Development Setup:</strong></p>
            <p>Make sure the Astro server is running and the app exists.</p>
          ` : `
            <p><strong>This app might be temporarily unavailable.</strong></p>
            <p>Please try again or browse our other apps.</p>
          `}
          <div class="error-actions">
            <button onclick="window.location.reload()">Retry</button>
            <button onclick="window.history.back()">Go Back</button>
          </div>
        </div>
      </div>
    `;
  }

  destroy() {
    // Clean up if needed
    if (this.container) {
      this.container.innerHTML = '';
    }
  }
} 